module.exports = __webpack_public_path__ + "img/eyes_male_round.e5231a5f.png";